import React, { useMemo } from 'react';

import BaseScore from 'pages/Bulletin/components/BaseScore';
import { UNKNOWN } from 'pages/components/ProtectedData';
import isEmptyRecursive from 'utils/is-empty-recursive';

interface Props {
    field: string;
    data: {
        source: string;
        value: {
            options: Record<string, string>[];
        };
    }[];
}

const Ssvc: React.FC<Props> = ({ data }) => {
    const baseScoreData = useMemo(
        () =>
            data.map(({ source, value }) => {
                return {
                    source,
                    score: UNKNOWN,
                    parts: value.options.reduce(
                        (accA, option) => ({
                            ...accA,
                            ...Object.entries(option).reduce((accB, [key, value]) => ({ ...accB, [key]: value }), {})
                        }),
                        {}
                    )
                };
            }),
        [data]
    );

    if (isEmptyRecursive(data)) {
        return null;
    }

    return <BaseScore label="SSVC" data={baseScoreData} />;
};

export default Ssvc;
